import { render, staticRenderFns } from "./twoChanging.vue?vue&type=template&id=2081f40b&scoped=true&"
import script from "./twoChanging.vue?vue&type=script&lang=js&"
export * from "./twoChanging.vue?vue&type=script&lang=js&"
import style0 from "./twoChanging.vue?vue&type=style&index=0&id=2081f40b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2081f40b",
  null
  
)

export default component.exports